import { Dispatch, SetStateAction } from "react";
import { IntegrationMessagesProps } from "models/QuoteDetail";
import { IQuoteDetailItemStock } from "models/QuoteDetailItem";
import { ProductSelectedProps } from "pages/Quotes/Details/interface";
import { CdFilterProps } from "pages/Quotes/components/DistributionCenterTab/interface";

export interface IQuoteItem {
  item: any;
  index: number;
  suggested: any;
  quoteId: string;
  checked: boolean;
  customerCode?: any;
  notifyLoading?: any;
  isEditingQuoteItem?: any;
  enableButtons?: boolean;
  cdFilter?: CdFilterProps;
  setEditingQuoteItem: any;
  setSelectedBudgetCd?: any;
  segmentsWithoutPriceLock: string[];
  distributionCenterSelected?: string;
  distributionCenterList?: Array<any>;
  customProps?: { [key: string]: any; };
  removeBudgetSaveQuoteItem: () => void;
  productSelected: ProductSelectedProps[];
  setChecked: Dispatch<SetStateAction<boolean>>;
  integrationMessages?: IntegrationMessagesProps;
  setSelectedCDItem: (selectedCD: string) => void;
  setTotalAmount: Dispatch<SetStateAction<number>>;
  refreshQuoteSentHeaderTabs: Function | undefined;
  updateConversionAmount: (quantity: number) => void;
  addNewHistory: (newBudget: NewBudgetProps) => void;
  setExclusionCondition?: Dispatch<SetStateAction<boolean>>;
  addBudgetSaveQuoteItem: (newBudget: NewBudgetProps) => void;
  setProductSelected: Dispatch<SetStateAction<ProductSelectedProps[]>>;
}

export const tooltipDefault = {
  quantity: false,
  rentability: false,
  unitPrice: false,
  unitPriceValue: 0
};

export interface NewBudgetProps {
  name: string;
  email: string;
  itemStock: any;
  suggested: any;
  status?: string;
  quoteId: string;
  subUnit: number;
  unitPrice: string;
  salePrice: string;
  totalValue: string;
  rentability: string;
  outOfStock: boolean;
  factoryPrice: number;
  pitagorasStock?: number;
  crmCustomerCode: string;
  sequenceBudget?: number;
  note: string | undefined;
  quotationMultiple: number;
  pitagorasPosition?: number;
  statusDescription?: string;
  distributionCenter: string;
  isPricedAccordingly: boolean;
  distributionCenterStock?: number;
  conversionAmount: number | string;
  quotationQuantityPackaging: number;
  sequenceNumber: number | undefined;
  isValuePricing: boolean | undefined;
  pitagorasDistributionCenter?: string;
  supplierProductCode: string | undefined;
  supplierProductCodeRA: string | undefined;
  acceptPriceBelowMin: boolean | undefined;
}

export interface SelectedColorProps {
  local: string;
  stock: number;
  position: number;
}

export interface DropdownCDsProps {
  index: number;
  disabled: boolean;
  isEditing: boolean;
  valueSelectDC: string;
  lengthQuoteItem: number;
  distributionCenter: string;
  valueSelectDCPitagoras: string;
  cdsPitagoras: SelectedColorProps[];
  distributionCenterPitagoras: string;
  stockAvailableList: IQuoteDetailItemStock[];
  setSelectedDc: (selectedCd: string) => void;
  setSelectedPitagoras: (selectedCdPitagoras: string) => void;
}